import React from 'react';
import { FaCheck } from 'react-icons/fa';

const PriceAreaOne = () => {
  // Function to handle smooth scrolling to sections
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };

  return (
    <>
      {/* Custom styles for pricing hover states */}
      <style dangerouslySetInnerHTML={{__html: `
        .single-pricing-inner:hover {
          color: white !important;
        }
        .single-pricing-inner:hover h2,
        .single-pricing-inner:hover h5,
        .single-pricing-inner:hover p,
        .single-pricing-inner:hover li {
          color: white !important;
          font-weight: bold !important;
        }
        .single-pricing-inner:hover svg {
          color: white !important;
        }
        .single-pricing-inner:hover button {
          background-color: white !important;
          color: #2c5aa0 !important;
          font-weight: bold !important;
          border: 2px solid white !important;
        }
        .single-pricing-inner:hover sub {
          color: white !important;
        }
      `}} />
      
      {/* pricing-area start */}
      <div id="precios" className="pricing-area pricing-area_1 pd-top-90 pd-bottom-90">
        <div className="container">
          <div className="section-title text-center">
            <h6 className="sub-title">PLANES Y PRECIOS</h6>
            <h2 className="title">
              Elige el plan perfecto para tu <span>empresa</span>
            </h2>
          </div>
          <div className="row">
            <div className="col-lg-4 col-md-6">
              <div className="single-pricing-inner style-3">
                <h2 className="mb-3">
                  1 UF + iva Mensual <sub>/mes</sub>
                </h2>
                <h5>Starter</h5>
                <p className="mb-3">Para equipos pequeños que envían documentos ocasionalmente</p>
                <ul>
                  <li>
                    <FaCheck />
                    Hasta 1.000 firmas
                  </li>
                  <li>
                    <FaCheck />
                    1 usuario
                  </li>
                  <li>
                    <FaCheck />
                    Validacion OTP
                  </li>
                  <li className="hide">
                    <FaCheck />
                    Soporte por Mail
                  </li>
                  <li className="hide">
                    <FaCheck />
                    Auditoría avanzada
                  </li>
                </ul>
                <button
                  onClick={() => scrollToSection('contacto')}
                  className="btn btn-black border-radius border-radius-0 w-100"
                >
                  Consultar →
                </button>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="single-pricing-inner style-3 price-active" style={{color: 'white'}}>
                <h2 className="mb-3" style={{color: 'white', fontWeight: 'bold'}}>
                  3 UF + iva Mensual <sub style={{color: 'white'}}>/mes</sub>
                </h2>
                <h5 style={{color: 'white', fontWeight: 'bold'}}>Pro</h5>
                <p className="mb-3" style={{color: 'white', fontWeight: 'bold'}}>Para áreas de RR.HH. y operaciones con mayor volumen</p>
                <ul>
                  <li style={{color: 'white', fontWeight: 'bold'}}>
                    <FaCheck style={{color: 'white'}} />
                    Hasta 3.000 firmas
                  </li>
                  <li style={{color: 'white', fontWeight: 'bold'}}>
                    <FaCheck style={{color: 'white'}} />
                    3 usuarios
                  </li>
                  <li style={{color: 'white', fontWeight: 'bold'}}>
                    <FaCheck style={{color: 'white'}} />
                    Validacion OTP
                  </li>
                  <li style={{color: 'white', fontWeight: 'bold'}}>
                    <FaCheck style={{color: 'white'}} />
                    Soporte por Mail
                  </li>
                  <li style={{color: 'white', fontWeight: 'bold'}}>
                    <FaCheck style={{color: 'white'}} />
                    Auditoría avanzada
                  </li>
                  <li style={{color: 'white', fontWeight: 'bold'}}>
                    <FaCheck style={{color: 'white'}} />
                    Soporte prioritario
                  </li>
                </ul>
                <button
                  onClick={() => scrollToSection('contacto')}
                  className="btn btn-white border-radius border-radius-0 w-100"
                  style={{color: '#2c5aa0', fontWeight: 'bold', backgroundColor: 'white', border: '2px solid white'}}
                >
                  Solicitar demo →
                </button>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="single-pricing-inner style-3">
                <h2 className="mb-3">
                  5 UF + iva Mensual <sub>/mes</sub>
                </h2>
                <h5>Empresa</h5>
                <p className="mb-3">Para necesidades a la medida y compliance interno</p>
                <ul>
                  <li>
                    <FaCheck />
                    Firmas ilimitadas
                  </li>
                  <li>
                    <FaCheck />
                    5 usuarios
                  </li>
                  <li>
                    <FaCheck />
                    Validacion OTP
                  </li>
                  <li>
                    <FaCheck />
                    API personalizada
                  </li>
                  <li>
                    <FaCheck />
                    Onboarding dedicado
                  </li>
                  <li>
                    <FaCheck />
                    SLA garantizado
                  </li>
                  <li>
                    <FaCheck />
                    La mas alta prioridad en soporte: via email/telefono
                  </li>
                </ul>
                <button
                  onClick={() => scrollToSection('contacto')}
                  className="btn btn-black border-radius border-radius-0 w-100"
                >
                  Hablar con ventas →
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* pricing-area end */}
    </>
  );
};

export default PriceAreaOne;
